export default {
  "content": "<path fill=\"#EA3917\" d=\"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z\"/><path fill=\"#fff\" d=\"M7.083 13.375c0 .619.525 1.125 1.167 1.125h3.5c.642 0 1.167-.506 1.167-1.125L13.5 7.75h-7l.583 5.625zm6.417-6.75a.562.562 0 00-.563-.563h-1.479l-.583-.562h-1.75l-.583.563h-1.48a.563.563 0 000 1.125h5.875a.563.563 0 00.563-.563z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};